export const itemIcons: Record<string, string> = {
    'btn-apetizer': 'assets/images/icons/items/BTN-APETIZER_C1.svg',
    'btn-beer': 'assets/images/icons/items/BTN-BEER_C1.svg',
    'btn-cofee': 'assets/images/icons/items/BTN-COFEE_C1.svg',
    'btn-dessert': 'assets/images/icons/items/BTN-DESSERT_C1.svg',
    'btn-draft-beer': 'assets/images/icons/items/BTN-DRAFT-BEER_C1.svg',
    'btn-first-dishes-c1': 'assets/images/icons/items/BTN-FIRST-DISHES_C1.svg',
    'btn-pizza-c1': 'assets/images/icons/items/BTN-PIZZA_C1.svg',
    'btn-pub-and-drinks-c1': 'assets/images/icons/items/BTN-PUB-AND-DRINKS_C1.svg',
    'btn-salades-c1': 'assets/images/icons/items/BTN-SALADES_C1.svg',
    'btn-second-dishes-c1': 'assets/images/icons/items/BTN-SECOND-DISHES_C1.svg',
    'btn-side-dish-c1': 'assets/images/icons/items/BTN-SIDE-DISH_C1.svg',
    'btn-wines-c1': 'assets/images/icons/items/BTN-WINES_C1.svg',
    'icon-apple-c1': 'assets/images/icons/items/ICON-APPLE_C1.svg',
    'icon-asparagus-c1': 'assets/images/icons/items/ICON-ASPARAGUS_C1.svg',
    'icon-avocado-c1': 'assets/images/icons/items/ICON-AVOCADO_C1.svg',
    'icon-baby-milk-c1': 'assets/images/icons/items/ICON-BABY-MILK_C1.svg',
    'icon-bacon-c1': 'assets/images/icons/items/ICON-BACON_C1.svg',
    'icon-banana-c1': 'assets/images/icons/items/ICON-BANANA_C1.svg',
    'icon-banana-split-c1': 'assets/images/icons/items/ICON-BANANA-SPLIT_C1.svg',
    'icon-bar-c1': 'assets/images/icons/items/ICON-BAR_C1.svg',
    'icon-bavarian-beer-mug-c1': 'assets/images/icons/items/ICON-BAVARIAN-BEER-MUG_C1.svg',
    'icon-bavarian-pretzel-c1': 'assets/images/icons/items/ICON-BAVARIAN-PRETZEL_C1.svg',
    'icon-bavarian-wheat-beer-c1': 'assets/images/icons/items/ICON-BAVARIAN-WHEAT-BEER_C1.svg',
    'icon-beer-c1': 'assets/images/icons/items/ICON-BEER_C1.svg',
    'icon-beer-bottle-c1': 'assets/images/icons/items/ICON-BEER-BOTTLE_C1.svg',
    'icon-beer-glass-c1': 'assets/images/icons/items/ICON-BEER-GLASS_C1.svg',
    'icon-beer-keg-c1': 'assets/images/icons/items/ICON-BEER-KEG_C1.svg',
    'icon-beet-c1': 'assets/images/icons/items/ICON-BEET_C1.svg',
    'icon-bento-c1': 'assets/images/icons/items/ICON-BENTO_C1.svg',
    'icon-big-green-egg-c1': 'assets/images/icons/items/ICON-BIG-GREEN-EGG_C1.svg',
    'icon-bottle-of-water-c1': 'assets/images/icons/items/ICON-BOTTLE-OF-WATER_C1.svg',
    'icon-bread-c1': 'assets/images/icons/items/ICON-BREAD_C1.svg',
    'icon-broccoli-c1': 'assets/images/icons/items/ICON-BROCCOLI_C1.svg',
    'icon-bull-c1': 'assets/images/icons/items/ICON-BULL_C1.svg',
    'icon-cabbage-c1': 'assets/images/icons/items/ICON-CABBAGE_C1.svg',
    'icon-cafe-c1': 'assets/images/icons/items/ICON-CAFE_C1.svg',
    'icon-caloric-energy-c1': 'assets/images/icons/items/ICON-CALORIC-ENERGY_C1.svg',
    'icon-carboydrates-c1': 'assets/images/icons/items/ICON-CARBOYDRATES_C1.svg',
    'icon-carrot-c1': 'assets/images/icons/items/ICON-CARROT_C1.svg',
    'icon-celery-c1': 'assets/images/icons/items/ICON-CELERY_C1.svg',
    'icon-charcoal-c1': 'assets/images/icons/items/ICON-CHARCOAL_C1.svg',
    'icon-cheese-c1': 'assets/images/icons/items/ICON-CHEESE_C1.svg',
    'icon-cherry-c1': 'assets/images/icons/items/ICON-CHERRY_C1.svg',
    'icon-chicken-c1': 'assets/images/icons/items/ICON-CHICKEN_C1.svg',
    'icon-chili-pepper-c1': 'assets/images/icons/items/ICON-CHILI-PEPPER_C1.svg',
    'icon-cinnamon-roll-c1': 'assets/images/icons/items/ICON-CINNAMON-ROLL_C1.svg',
    'icon-citrus-c1': 'assets/images/icons/items/ICON-CITRUS_C1.svg',
    'icon-cocktail-c1': 'assets/images/icons/items/ICON-COCKTAIL_C1.svg',
    'icon-coconut-cocktail-c1': 'assets/images/icons/items/ICON-COCONUT-COCKTAIL_C1.svg',
    'icon-coffee-to-go-c1': 'assets/images/icons/items/ICON-COFFEE-TO-GO_C1.svg',
    'icon-coocker-to-go-c1': 'assets/images/icons/items/ICON-COOKER_C1.svg',
    'icon-coocker-hood-c1': 'assets/images/icons/items/ICON-COOKER-HOOD_C1.svg',
    'icon-cookies-c1': 'assets/images/icons/items/ICON-COOKIES_C1.svg',
    'icon-corn-c1': 'assets/images/icons/items/ICON-CORN_C1.svg',
    'icon-cotton-candy-c1': 'assets/images/icons/items/ICON-COTTON-CANDY_C1.svg',
    'icon-cow-c1': 'assets/images/icons/items/ICON-COW_C1.svg',
    'icon-crab-c1': 'assets/images/icons/items/ICON-CRAB_C1.svg',
    'icon-cucumber-c1': 'assets/images/icons/items/ICON-CUCUMBER_C1.svg',
    'icon-cupcake-c1': 'assets/images/icons/items/ICON-CUPCAKE_C1.svg',
    'icon-deliver-food-c1': 'assets/images/icons/items/ICON-DELIVER-FOOD_C1.svg',
    'icon-dolmades-c1': 'assets/images/icons/items/ICON-DOLMADES_C1.svg',
    'icon-doughnut-c1': 'assets/images/icons/items/ICON-DOUGHNUT_C1.svg',
    'icon-dragon-fruit-c1': 'assets/images/icons/items/ICON-DRAGON-FRUIT_C1.svg',
    'icon-duck-c1': 'assets/images/icons/items/ICON-DUCK_C1.svg',
    'icon-eggplant-c1': 'assets/images/icons/items/ICON-EGGPLANT_C1.svg',
    'icon-eggs-c1': 'assets/images/icons/items/ICON-EGGS_C1.svg',
    'icon-fiber-c1': 'assets/images/icons/items/ICON-FIBER_C1.svg',
    'icon-fish-c1': 'assets/images/icons/items/ICON-FISH_C1.svg',
    'icon-fish-food-c1': 'assets/images/icons/items/ICON-FISH-FOOD_C1.svg',
    'icon-french-fries-c1': 'assets/images/icons/items/ICON-FRENCH-FRIES_C1.svg',
    'icon-fridge-c1': 'assets/images/icons/items/ICON-FRIDGE_C1.svg',
    'icon-garlic-c1': 'assets/images/icons/items/ICON-GARLIC_C1.svg',
    'icon-grapes-c1': 'assets/images/icons/items/ICON-GRAPES_C1.svg',
    'icon-grill-c1': 'assets/images/icons/items/ICON-GRILL_C1.svg',
    'icon-hamburger-c1': 'assets/images/icons/items/ICON-HAMBURGER_C1.svg',
    'icon-hazelnut-c1': 'assets/images/icons/items/ICON-HAZELNUT_C1.svg',
    'icon-honey-c1': 'assets/images/icons/items/ICON-HONEY_C1.svg',
    'icon-hops-c1': 'assets/images/icons/items/ICON-HOPS_C1.svg',
    'icon-horse-c1': 'assets/images/icons/items/ICON-HORSE_C1.svg',
    'icon-hot-chocolate-c1': 'assets/images/icons/items/ICON-HOT-CHOCOLATE_C1.svg',
    'icon-hot-dog-c1': 'assets/images/icons/items/ICON-HOT-DOG_C1.svg',
    'icon-ice-cream-cone-c1': 'assets/images/icons/items/ICON-ICE-CREAM-CONE_C1.svg',
    'icon-icream-bowl-c1': 'assets/images/icons/items/ICON-ICREAM-BOWL_C1.svg', 
    'icon-ingredients-c1': 'assets/images/icons/items/ICON-INGREDIENTS_C1.svg',
    'icon-ingredients-list-c1': 'assets/images/icons/items/ICON-INGREDIENTS-LIST_C1.svg',
    'icon-kebab-c1': 'assets/images/icons/items/ICON-KEBAB_C1.svg',
    'icon-kettle-c1': 'assets/images/icons/items/ICON-KETTLE_C1.svg',
    'icon-kiwi-c1': 'assets/images/icons/items/ICON-KIWI_C1.svg',
    'icon-kohlrabi-c1': 'assets/images/icons/items/ICON-KOHLRABI_C1.svg',
    'icon-leek-c1': 'assets/images/icons/items/ICON-LEEK_C1.svg',
    'icon-lettuce-c1': 'assets/images/icons/items/ICON-LETTUCE_C1.svg',
    'icon-lipidis-c1': 'assets/images/icons/items/ICON-LIPIDIS_C1.svg',
    'icon-macaron-c1': 'assets/images/icons/items/ICON-MACARON_C1.svg',
    'icon-meal-c1': 'assets/images/icons/items/ICON-MEAL_C1.svg',
    'icon-melon-c1': 'assets/images/icons/items/ICON-MELON_C1.svg',
    'icon-microwave-c1': 'assets/images/icons/items/ICON-MICROWAVE_C1.svg',
    'icon-milk-c1': 'assets/images/icons/items/ICON-MILK_C1.svg',
    'icon-milk-bottle-c1': 'assets/images/icons/items/ICON-MILK-BOTTLE_C1.svg',
    'icon-mixer-c1': 'assets/images/icons/items/ICON-MIXER_C1.svg',
    'icon-mushroom-c1': 'assets/images/icons/items/ICON-MUSHROOM_C1.svg',
    'icon-nachos-c1': 'assets/images/icons/items/ICON-NACHOS_C1.svg',
    'icon-natural-food-c1': 'assets/images/icons/items/ICON-NATURAL-FOOD_C1.svg',
    'icon-noodles-c1': 'assets/images/icons/items/ICON-NOODLES_C1.svg',
    'icon-nut-c1': 'assets/images/icons/items/ICON-NUT_C1.svg',
    'icon-octopus-c1': 'assets/images/icons/items/ICON-OCTOPUS_C1.svg',
    'icon-olive-oil-c1': 'assets/images/icons/items/ICON-OLIVE-OIL_C1.svg',
    'icon-onion-c1': 'assets/images/icons/items/ICON-ONION_C1.svg',
    'icon-organic-food-c1': 'assets/images/icons/items/ICON-ORGANIC-FOOD_C1.svg',
    'icon-pancake-c1': 'assets/images/icons/items/ICON-PANCAKE_C1.svg',
    'icon-paprika-c1': 'assets/images/icons/items/ICON-PAPRIKA_C1.svg',
    'icon-peach-c1': 'assets/images/icons/items/ICON-PEACH_C1.svg',
    'icon-peanuts-c1': 'assets/images/icons/items/ICON-PEANUTS_C1.svg',
    'icon-pear-c1': 'assets/images/icons/items/ICON-PEAR_C1.svg',
    'icon-peas-c1': 'assets/images/icons/items/ICON-PEAS_C1.svg',
    'icon-pie-c1': 'assets/images/icons/items/ICON-PIE_C1.svg',
    'icon-pig-c1': 'assets/images/icons/items/ICON-PIG_C1.svg',
    'icon-pineapple-c1': 'assets/images/icons/items/ICON-PINEAPPLE_C1.svg',
    'icon-pizza-c1': 'assets/images/icons/items/ICON-PIZZA_C1.svg',
    'icon-plum-c1': 'assets/images/icons/items/ICON-PLUM_C1.svg',
    'icon-pomegranate-c1': 'assets/images/icons/items/ICON-POMEGRANATE_C1.svg',
    'icon-potato-c1': 'assets/images/icons/items/ICON-POTATO_C1.svg',
    'icon-prawn-c1': 'assets/images/icons/items/ICON-PRAWN_C1.svg',
    'icon-protein-c1': 'assets/images/icons/items/ICON-PROTEIN_C1.svg',
    'icon-quesadilla-c1': 'assets/images/icons/items/ICON-QUESADILLA_C1.svg',
    'icon-rack-of-lamb-c1': 'assets/images/icons/items/ICON-RACK-OF-LAMB_C1.svg',
    'icon-radish-c1': 'assets/images/icons/items/ICON-RADISH_C1.svg',
    'icon-raspberry-c1': 'assets/images/icons/items/ICON-RASPBERRY_C1.svg',
    'icon-restaurant-c1': 'assets/images/icons/items/ICON-RESTAURANT_C1.svg',
    'icon-restaurant-bui-c1': 'assets/images/icons/items/ICON-RESTAURANT-BUI_C1.svg',
    'icon-restaurant-building-c1': 'assets/images/icons/items/ICON-RESTAURANT-BUILDING_C1.svg',
    'icon-restaurant-memb-c1': 'assets/images/icons/items/ICON-RESTAURANT-MEMB_C1.svg',
    'icon-restaurant-membership-card-c1': 'assets/images/icons/items/ICON-RESTAURANT-MEMBERSHIP-CARD_C1.svg',
    'icon-restaurant-pickup-c1': 'assets/images/icons/items/ICON-RESTAURANT-PICKUP_C1.svg',
    'icon-rice-bowl-filled-c1': 'assets/images/icons/items/ICON-RICE-BOWL-FILLED_C1.svg',
    'icon-sack-of-flour-c1': 'assets/images/icons/items/ICON-SACK-OF-FLOUR_C1.svg',
    'icon-sesame-c1': 'assets/images/icons/items/ICON-SESAME_C1.svg',
    'icon-sheep-c1': 'assets/images/icons/items/ICON-SHEEP_C1.svg',
    'icon-shellfish-c1': 'assets/images/icons/items/ICON-SHELLFISH_C1.svg',
    'icon-soda-bottle-c1': 'assets/images/icons/items/ICON-SODA-BOTTLE_C1.svg',
    'icon-sodium-c1': 'assets/images/icons/items/ICON-SODIUM_C1.svg',
    'icon-soy-c1': 'assets/images/icons/items/ICON-SOY_C1.svg',
    'icon-spaghetti-c1': 'assets/images/icons/items/ICON-SPAGHETTI_C1.svg',
    'icon-spoon-of-sugar-c1': 'assets/images/icons/items/ICON-SPOON-OF-SUGAR_C1.svg',
    'icon-steak-c1': 'assets/images/icons/items/ICON-STEAK_C1.svg',
    'icon-strawberry-c1': 'assets/images/icons/items/ICON-STRAWBERRY_C1.svg',
    'icon-sugar-c1': 'assets/images/icons/items/ICON-SUGAR_C1.svg',
    'icon-sugar-cube-c1': 'assets/images/icons/items/ICON-SUGAR-CUBE_C1.svg',
    'icon-sugar-cubes-c1': 'assets/images/icons/items/ICON-SUGAR-CUBES_C1.svg',
    'icon-sushi-c1': 'assets/images/icons/items/ICON-SUSHI_C1.svg',
    'icon-sweet-potato-c1': 'assets/images/icons/items/ICON-SWEET-POTATO_C1.svg',
    'icon-sweetener-c1': 'assets/images/icons/items/ICON-SWEETENER_C1.svg',
    'icon-taco-c1': 'assets/images/icons/items/ICON-TACO_C1.svg',
    'icon-tapas-c1': 'assets/images/icons/items/ICON-TAPAS_C1.svg',
    'icon-tea-c1': 'assets/images/icons/items/ICON-TEA_C1.svg',
    'icon-tomato-c1': 'assets/images/icons/items/ICON-TOMATO_C1.svg',
    'icon-vegan-food-c1': 'assets/images/icons/items/ICON-VEGAN-FOOD_C1.svg',
    'icon-vegan-symbol-c1': 'assets/images/icons/items/ICON-VEGAN-SYMBOL_C1.svg',
    'icon-vegetarian-food-c1': 'assets/images/icons/items/ICON-VEGETARIAN-FOOD_C1.svg',
    'icon-waiter-c1': 'assets/images/icons/items/ICON-WAITER_C1.svg',
    'icon-watermelon-c1': 'assets/images/icons/items/ICON-WATERMELON_C1.svg',
    'icon-weber-c1': 'assets/images/icons/items/ICON-WEBER_C1.svg',
    'icon-wine-bottle-c1': 'assets/images/icons/items/ICON-WINE-BOTTLE_C1.svg',
    'icon-wine-glass-c1': 'assets/images/icons/items/ICON-WINE-GLASS_C1.svg',
    'icon-wooden-beer-keg-c1': 'assets/images/icons/items/ICON-WOODEN-BEER-KEG_C1.svg',
    'icon-wrap-c1': 'assets/images/icons/items/ICON-WRAP_C1.svg'
}

export const icons: Record<string, string> = {
    ...itemIcons,
    'whatsapp': 'assets/images/icons/action/ic_whatsapp_24px.svg',
    'analytics': 'assets/images/icons/analytics/Analytics-f-24.svg',
    'ph_wall_h': 'assets/images/tables/furnitures/ph_wall_h.svg',
    'ph_wall_v': 'assets/images/tables/furnitures/ph_wall_v.svg',
    'ph_plant1': 'assets/images/tables/furnitures/ph_plant1.svg',
    'ph_plant2': 'assets/images/tables/furnitures/ph_plant2.svg',
    'ph_armchair_dx': 'assets/images/tables/furnitures/01_Poltrona_destra.svg',
    'ph_armchair_sx': 'assets/images/tables/furnitures/01_Poltrona_sinistra.svg',
    'ph_armchair_top': 'assets/images/tables/furnitures/01_Poltrona_sopra.svg',
    'ph_armchair_bottom': 'assets/images/tables/furnitures/01_Poltrona_sotto.svg',
    'ph_sofa_dx': 'assets/images/tables/furnitures/02_Divano_destra.svg',
    'ph_sofa_sx': 'assets/images/tables/furnitures/02_Divano_sinistra.svg',
    'ph_sofa_top': 'assets/images/tables/furnitures/02_Divano_sopra.svg',
    'ph_sofa_bottom': 'assets/images/tables/furnitures/02_Divano_sotto.svg',
    'ph_plant': 'assets/images/tables/furnitures/03_Pianta.svg',
    'ph_cashreg_counter': 'assets/images/tables/furnitures/04_BancoCassa.svg',
    'ph_cashreg_only': 'assets/images/tables/furnitures/04_SoloCassa.svg',
    'square': 'assets/images/tables/shapes/01_Quadrato_4Posti.svg',
    'circle4': 'assets/images/tables/shapes/02_Circolare_4Posti.svg',
    'circle8': 'assets/images/tables/shapes/03_Circolare_8Posti.svg',
    'oval_hor': 'assets/images/tables/shapes/04_Ovale_6Posti.svg',
    'oval_vert': 'assets/images/tables/shapes/04_OvaleVerticale_6Posti.svg',
    'rect_hor_6': 'assets/images/tables/shapes/05_Rettangolare_6Posti.svg',
    'rect_vert_6': 'assets/images/tables/shapes/05_RettangolareVerticale_6Posti.svg',
    'rect_hor_12': 'assets/images/tables/shapes/06_Rettangolare_12Posti.svg',
    'rect_vert_12': 'assets/images/tables/shapes/06_RettangolareVerticale_12Posti.svg',
    'counter_top': 'assets/images/tables/shapes/07_Bancone_sopra.svg',
    'counter_bottom': 'assets/images/tables/shapes/07_Bancone_sotto.svg',
    'counter_dx': 'assets/images/tables/shapes/07_BanconeVerticale_destra.svg',
    'counter_sx': 'assets/images/tables/shapes/07_BanconeVerticale_sinistra.svg',
    'chair_dx': 'assets/images/tables/shapes/08_Sedia_destra.svg',
    'chair_sx': 'assets/images/tables/shapes/08_Sedia_sinistra.svg',
    'chair_top': 'assets/images/tables/shapes/08_Sedia_sopra.svg',
    'chair_bottom': 'assets/images/tables/shapes/08_Sedia_sotto.svg',
    'weather-big-snow': 'assets/images/icons/weather/weather-big-snow.svg',
    'weather-clear-night': 'assets/images/icons/weather/weather-clear-night.svg',
    'weather-clear': 'assets/images/icons/weather/weather-clear.svg',
    'weather-clouds-night': 'assets/images/icons/weather/weather-clouds-night.svg',
    'weather-clouds': 'assets/images/icons/weather/weather-clouds.svg',
    'weather-drizzle-day': 'assets/images/icons/weather/weather-drizzle-day.svg',
    'weather-drizzle-night': 'assets/images/icons/weather/weather-drizzle-night.svg',
    'weather-few-clouds-night': 'assets/images/icons/weather/weather-few-clouds-night.svg',
    'weather-few-clouds': 'assets/images/icons/weather/weather-few-clouds.svg',
    'weather-fog': 'assets/images/icons/weather/weather-fog.svg',
    'weather-hail': 'assets/images/icons/weather/weather-hail.svg',
    'weather-haze': 'assets/images/icons/weather/weather-haze.svg',
    'weather-mist': 'assets/images/icons/weather/weather-mist.svg',
    'weather-none-available': 'assets/images/icons/weather/weather-none-available.svg',
    'weather-rain-day': 'assets/images/icons/weather/weather-rain-day.svg',
    'weather-rain-night': 'assets/images/icons/weather/weather-rain-night.svg',
    'weather-showers-day': 'assets/images/icons/weather/weather-showers-day.svg',
    'weather-showers-night': 'assets/images/icons/weather/weather-showers-night.svg',
    'weather-showers-scattered-day': 'assets/images/icons/weather/weather-showers-scattered-day.svg',
    'weather-showers-scattered-night': 'assets/images/icons/weather/weather-showers-scattered-night.svg',
    'weather-snow-rain': 'assets/images/icons/weather/weather-snow-rain.svg',
    'weather-snow': 'assets/images/icons/weather/weather-snow.svg',
    'weather-storm-day': 'assets/images/icons/weather/weather-storm-day.svg',
    'weather-storm-night': 'assets/images/icons/weather/weather-storm-night.svg',
    'weather-storm': 'assets/images/icons/weather/weather-storm.svg',
    'weather-wind': 'assets/images/icons/weather/weather-wind.svg',
    'alvolo': 'assets/images/icons/alvolo/alvolo_logo.svg',
    'alvolo-dark': 'assets/images/icons/alvolo/alvolo_logo-dark.svg',
    'pienissimo': 'assets/images/icons/pienissimo/pienissimo-logo.svg',
    'lottery_code': 'assets/images/icons/hand_fingers_crossed.svg',
    'thefork': 'assets/images/channels/thefork.png',
    'plateform': 'assets/images/channels/plateform.png',
    'lean': 'assets/images/channels/lean.png'
};